// src/components/ViewLeads.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';

const ViewLeads = () => {
  const [leads, setLeads] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchLeads = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setError('You must be logged in as admin.');
        return;
      }

      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/admin/leads`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        // Sort leads by latest first (by dateTime)
        const sortedLeads = res.data.sort((a, b) => new Date(b.dateTime) - new Date(a.dateTime));
        setLeads(sortedLeads);
      } catch (err) {
        console.error(err);
        setError(err.response?.data?.error || 'Failed to load leads.');
      }
    };

    fetchLeads();
  }, []);

  return (
    <div className="container mt-5">
      <h2 className="mb-4">Submitted Job Leads</h2>
      {error && <div className="alert alert-danger">{error}</div>}
      {!leads.length ? (
        <p>No leads found.</p>
      ) : (
        <ul className="list-group">
          {leads.map((lead) => (
            <li key={lead._id} className="list-group-item">
              <strong>{lead.customerName}</strong><br />
              {lead.customerEmail} | {lead.customerPhone}<br />
              <em>
                {lead.from} → {lead.to} @{' '}
                {new Date(lead.dateTime).toLocaleString()}
              </em>
              <br />
              <span>Status: {lead.status}</span>
              {lead.acceptedBy && (
                <div>
                  Accepted by: {lead.acceptedBy.name} (
                  {lead.acceptedBy.email})
                </div>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ViewLeads;
